import React, { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import { Navigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { getUserById } from "../api/User/userApi";
import { parseProveedoresPermitidos } from "../utils/proveedorPermissionsUtils";
import { canAccessPath } from "./navCatalog";

const DENIED_REDIRECT = "/mi-dashboard";

const PrivateRoute = ({ component: Component }) => {
  const location = useLocation();
  const token = localStorage.getItem("token");
  const [gate, setGate] = useState("loading");

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      if (!token) {
        setGate("login");
        return;
      }

      try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        if (decodedToken.exp < currentTime) {
          localStorage.removeItem("token");
          if (!cancelled) setGate("login");
          return;
        }

        const userId = decodedToken.userId ?? decodedToken.id;
        const user = await getUserById(userId);
        if (cancelled) return;

        const hasProveedorLimit =
          parseProveedoresPermitidos(user?.ProveedoresPermitidos).length > 0;
        const allowed = canAccessPath(location.pathname, user, {
          hasProveedorLimit,
        });
        setGate(allowed ? "ok" : "denied");
      } catch {
        if (!cancelled) setGate("login");
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [token, location.pathname]);

  if (gate === "login") {
    return <Navigate to="/login" replace />;
  }

  if (gate === "denied") {
    if (location.pathname === DENIED_REDIRECT) {
      return <Navigate to="/login" replace />;
    }
    return <Navigate to={DENIED_REDIRECT} replace />;
  }

  if (gate !== "ok") {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", pt: 8 }}>
        <CircularProgress size={28} />
      </Box>
    );
  }

  return <Component />;
};

export default PrivateRoute;
